//@flow
import type { GlobalContextState } from './types.flow'

const initialState: GlobalContextState = {
  auth: {},
  pbx: {
    id: '',
    version: '',
    hostname: '',
    modules: {},
    settings: {},
    reload: false
  },
  permissions: [],
  modal: {
    title: '',
    content: null,
    isCloseDisabled: false
  }
}

export default initialState
